import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useAuth } from '../context/AuthContext';
import { Loader, Body, Alert } from '../components/kern';

export function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleOidcCallback } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const errorParam = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (errorParam) {
      setError(errorDescription || errorParam);
      return;
    }

    if (!code || !state) {
      setError('Fehlende Authentifizierungsparameter');
      return;
    }

    handleOidcCallback(code, state)
      .then(() => {
        navigate('/dashboard', { replace: true });
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : 'Authentifizierung fehlgeschlagen');
      });
  }, [searchParams, navigate, handleOidcCallback]);

  if (error) {
    return (
      <div className="login-page">
        <div className="loading-container">
          <Alert variant="danger" title="Authentifizierungsfehler">
            {error}
          </Alert>
          <div style={{ marginTop: '16px' }}>
            <a href="/login">Zurück zur Anmeldung</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="loading-container">
        <Loader />
        <Body>Authentifizierung wird abgeschlossen...</Body>
      </div>
    </div>
  );
}
